import React from "react";

export default function Terms() {
  return (
    <div className="main-container">
      <img src="/logo-foxorox.png" alt="Foxorox Logo" className="logo" />
      <h1 className="highlight">Terms of Use</h1>

      <div className="subtitle" style={{ textAlign: "left", maxWidth: "800px", margin: "0 auto" }}>
        <p><strong>Last updated: July 01, 2025</strong></p>

        <h2>1. Agreement to Legal Terms</h2>
        <p>
          These Terms and Conditions ("Legal Terms") constitute a legally binding agreement made between you ("User", "you") and <strong>Foxorox Sp. z o.o.</strong> ("Company", "we", "us", "our"), a limited liability company based in Poland, with registered office in Mieruniszki, operating the desktop application and website <a href="https://foxorox.com" target="_blank" rel="noopener noreferrer">https://foxorox.com</a> (the "Services").
        </p>
        <p>
          By accessing or using any part of the Services, you agree that you have read, understood, and agreed to be bound by these Legal Terms. If you do not agree with all of these Legal Terms, you are expressly prohibited from using the Services and must discontinue use immediately.
        </p>
        <p>
          We reserve the right to modify these Legal Terms at any time. When changes are made, we will revise the "Last updated" date. Your continued use of the Services constitutes your acceptance of such changes.
        </p>
        <p>
          The Services are intended for users who are at least 18 years old.
        </p>

        <h2>2. Our Services</h2>
        <p>
          Foxorox provides users with an AI-powered stock market data analysis platform. The software is available as a desktop application, and users may access certain functionalities via the website. The platform uses publicly available financial data and proprietary machine learning algorithms to deliver statistical analyses.
        </p>
        <p>
          Foxorox <strong>does not</strong> offer or provide investment advice, portfolio management, brokerage services, or securities recommendations. All information is provided for <strong>educational and informational purposes only</strong>.
        </p>
        <p>
          Due to the scope of data processed (including thousands of stock listings and multiple learning branches), the application may take up to <strong>5 minutes</strong> to complete its analysis after launch.
        </p>
        <p>
          Use of the Services is <strong>at your own risk</strong>, and you agree that any investment decisions you make are your sole responsibility.
        </p>

        <h2>3. Jurisdiction and Governing Law</h2>
        <p>
          These Legal Terms are governed by and construed in accordance with the laws of <strong>Poland</strong>, without regard to conflict of laws principles. Any disputes arising out of or relating to these Legal Terms shall be subject to the <strong>exclusive jurisdiction of Polish courts</strong>, unless otherwise required by mandatory law.
        </p>
        <p>
          Users outside Poland, including from the United States or European Union, access the Services on their own initiative and are responsible for compliance with local laws. Foxorox shall not be liable for any legal violations resulting from such access.
        </p>

        <h2>4. No Financial Advice</h2>
        <p>
          Nothing in the Services constitutes, or is intended to constitute:
        </p>
        <ul>
          <li>Investment advice</li>
          <li>A recommendation to buy, sell, or hold any financial instrument</li>
          <li>A promise of performance or profit</li>
        </ul>
        <p>
          You acknowledge that Foxorox is <strong>not</strong> a licensed financial advisor or investment firm in any jurisdiction, including Poland, the EU, or the United States. All content and functionality is provided for general informational purposes only and must not be relied upon to make investment decisions.
        </p>

        <h2>5. User Obligations</h2>
        <p>By using the Services, you agree to:</p>
        <ul>
          <li>Use the platform only for lawful, personal, and non-commercial purposes</li>
          <li>Refrain from copying, reselling, or reverse engineering the software</li>
          <li>Not use the platform to commit fraud or mislead others</li>
          <li>Accept that all use is at your own discretion and risk</li>
        </ul>
        <p>
          You are solely responsible for complying with any applicable tax or regulatory reporting obligations that may arise from your use of the Services.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, Foxorox disclaims all liability for:
        </p>
        <ul>
          <li>Any financial losses or damages incurred as a result of using or relying on the Services</li>
          <li>Interruptions, errors, or inaccuracies in the application</li>
          <li>Actions taken by users based on AI-generated predictions</li>
        </ul>
        <p>
          Foxorox’s total liability under any legal theory shall be limited to the amount you paid (if any) to access the Services during the 12-month period preceding the claim.
        </p>

        <h2>7. Indemnification</h2>
        <p>
          You agree to indemnify, defend, and hold harmless Foxorox Sp. z o.o., its affiliates, employees, and licensors from and against any and all claims, losses, damages, liabilities, and expenses (including reasonable attorney fees) arising from your use of the Services, violation of these Legal Terms, or infringement of any rights of third parties.
        </p>

        <h2>8. Subscriptions and Payments</h2>
        <p>
          Access to certain features may require a paid subscription. By purchasing a plan, you agree to:
        </p>
        <ul>
          <li>Provide accurate and current billing information</li>
          <li>Authorize recurring charges (monthly or annually)</li>
          <li>Cancel before renewal if you no longer wish to continue</li>
        </ul>
        <p>
          Foxorox reserves the right to change pricing at any time and to suspend or terminate accounts for chargeback fraud or payment failure.
        </p>

        <h2>9. Termination</h2>
        <p>
          We may suspend or terminate your access to the Services without notice if we believe you have violated any provision of these Legal Terms. Upon termination, your right to use the Services will immediately cease.
        </p>

        <h2>10. Contact</h2>
        <p>If you have any questions about these Legal Terms or wish to contact us regarding a legal issue, please use the following details:</p>
        <p>
          <strong>Distributor of the program and owner of the site:</strong><br />
          Aerga Sp. z o.o.<br />
          Mieruniszki 44, 16-424 Filipów, Poland<br />
          Email: <a href="mailto:noreply.foxorox@gmail.com">noreply.foxorox@gmail.com</a>
        </p>

        <hr />
        <p>
          By using the Services, you acknowledge that you have read, understood, and agreed to be bound by these Terms and Conditions.
        </p>
      </div>
    </div>
  );
}
